

export const canAccessMessages = {
    get() {
      return localStorage.getItem(' canAccessMessages ') === 'true';
    },
    set(value) {
      localStorage.setItem(' canAccessMessages ', value);
    }
  };